// Libraries
import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 2.5rem;
`;

export const NetworkContainer = styled.div`
  display: flex;
  gap: 20px;
  padding-right: 0.5rem;
  flex: 1;
`;

export const NetworkStatusSection = styled.div`
  flex: 0 0 auto;
  width: 20%;
`;

export const NetworkCheckSection = styled.div`
  flex: 1;
  min-width: 0;
`;

export const NetworkCheckContainer = styled.div`
  padding-bottom: 1rem;
  flex-shrink: 0;
`;

const NetworkGridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.asiNetwork.borderColor};
  min-width: 1150px;
  gap: 16px;
  box-sizing: border-box;
  
  & > * {
    white-space: nowrap;
    text-align: center;
    box-sizing: border-box;
    
    &:first-child {
      text-align: left;
      padding: 0;
      margin: 0;
    }
    
    &:nth-child(2) {
      text-align: left;
      padding: 0;
      margin: 0;
    }
  }
`;

export const NetworkCheckHeaderContainer = styled(NetworkGridContainer)`
  padding: 0.5rem 0 1rem 0;
`;

export const NetworkItemsContainer = styled(NetworkGridContainer)`
  padding: 0.25rem 0;
`;

export const NetworkStatusContainer = styled.div`
  padding-bottom: 1rem;
`;

export const DiagnosticContainer = styled.div`
  display: flex;
  gap: 12px;
  border-bottom: 1px solid ${({ theme }) => theme.color.asiNetwork.borderColor};
  padding-bottom: 1rem;
  padding-top: 0.5rem;
`;

export const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.asiNetwork.borderColor};
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
`;

export const StatusIndicatorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0.875rem;
  width: 54px;
`;

export const NetworkParagraphContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const NetworkPeripheryStatus = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NetworkStatusIndicatorsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NetworkCheckTitleContainer = styled.div`
  padding-bottom: 1rem;
`;

export const HighlightCardsContainer = styled.div`
  display: flex;
  gap: 16px;
  padding-bottom: 1.5rem;
`;
